export default {
  init() {
    // JavaScript to be fired on all pages
    jQuery('#PrimaryNavToggle').on('click', function () {
      jQuery('#PrimaryNav')
          .addClass('active')
          .on('click', function (event) {
            jQuery(event.currentTarget).removeClass('active');
          });
    });

    // Dropdown-Content
    jQuery('.dropdown-content').on('click', function () {
      jQuery(this).toggleClass('open');
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js